import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=ed15374c&scoped=true&"
import script from "./DealList.vue?vue&type=script&lang=js&"
export * from "./DealList.vue?vue&type=script&lang=js&"
import style0 from "./DealList.vue?vue&type=style&index=0&id=ed15374c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed15374c",
  null
  
)

component.options.__file = "DealList.vue"
export default component.exports